<template>
  <v-container fluid
    class="container">
    <Breadcrumbs
      :items="breadcrumbs"/>
    <v-data-table fixed-header
      dense
      class="elevation-1"
      :page.sync="pagination.page"
      :server-items-length="pagination.total || items.length"
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-options': pagination.itemsPerPage
      }"
      :items-per-page="pagination.size">
      <template v-slot:top>
        <v-toolbar flat>
          <v-col cols="12" sm="3"
            class="px-0">
            <v-text-field
              clearable
              v-model="search"
              append-icon="mdi-magnify"
              :label="translate('products_search_items')"
              single-line
              hide-details
            ></v-text-field>
           </v-col>
          <v-spacer></v-spacer>
          <v-btn color="primary"
              @click.stop="addNewProductMappingsItem()">
            <v-icon class="mr-2">mdi-table-large-plus</v-icon>
            {{translate('products_new_mapping_item')}}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:header="props">
        <thead>
          <tr>
            <th :colspan="headers.length"
              class="text-center">
              {{translate('product_mapping_items')}}
            </th>
            </tr>
          <tr>
            <th v-for="(header, idx) in props.headers"
              :key="idx">
              {{header.text}}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="props">
        <tbody>
          <ProductMappingRow v-for="(item, idx) in props.items"
            v-show="!search || (item.name.indexOf(search) !== -1)"
            :ref="`row-${idx}`"
            :key="item.id || item.tempId"
            :item="item"
            :rowIndex="idx"
            @delete="deleteItem" />
          <tr v-if="!props.items.length"
            class="v-data-table__empty-wrapper">
            <td :colspan="headers.length">{{translate('no_items')}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-btn color="accent"
      fab
      fixed
      right
      bottom
      @click.stop="saveProductMapping()">
      <v-icon dark>mdi-content-save</v-icon>
    </v-btn>
    <Snackbar :text="notificationText"
      :type="notificationType" />
    <v-overlay :value="loader"
      :z-index="1000">
      <v-progress-circular indeterminate
        size="64"></v-progress-circular>
    </v-overlay>
    <ConfirmDialog
      :dialog="deleteDialog"
      :description="deleteDialogDescription"
      @change="setDialogState"
      @confirmDelete="confirmDeleteAction"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductMappingRow from '@/components/ProductMappingRow';
import ConfirmDialog from '@/components/ConfirmDialog';
import Snackbar from '../components/Snackbar';
import Breadcrumbs from '../components/Breadcrumbs';


import api from '../api/lbt-api';
import store from '../store/index';

const {
  getProductMapping,
  createProductMapping,
  // getOption,
  deleteProductMapping,
  updateProductMapping,
} = api;

export default {
  name: 'ProductMapping',
  components: {
    Snackbar,
    ProductMappingRow,
    Breadcrumbs,
    ConfirmDialog,
  },
  data() {
    return {
      search: '',
      notificationText: '',
      notificationType: '',
      deleteDialog: false,
      deleteDialogDescription: '',
      itemForDeletion: {},
      loader: false,
      headers: [],
      items: [],
      pagination: {
        page: 1,
        size: 25,
        total: 0,
        itemsPerPage: [25, 50, 100],
      },
      breadcrumbs: [
        {
          translationKey: 'sidebar_finprep_product_mapping',
          route: '/finrep-product-mapping',
          disabled: false,
        },
        {
          translationKey: 'sidebar_finprep_product_mapping',
          disabled: true,
        },
      ],

    };
  },
  async created() {
    this.loader = true;
    this.headers = [
      {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name',
      },
      {
        text: 'FINREP BS Code',
        align: 'left',
        sortable: false,
        value: 'finrep_bs_code',
      },
      {
        text: 'FINREP PL Code',
        align: 'left',
        sortable: false,
        value: 'finrep_pl_code',
      },
      {
        text: 'FINREP Summary BS Code',
        align: 'left',
        sortable: false,
        value: 'summary_bs_code',
      },
      {
        text: 'FINREP Summary PL Code',
        align: 'left',
        sortable: false,
        value: 'summary_pl_code',
      },
      {
        text: this.translate('table_actions'),
        align: 'left',
        sortable: false,
        value: 'actions',
      },
    ];
    try {
      await this.fetchProductMappingItems();
      // const option = await getOption(this.$route.params.optionId);
    } catch (message) {
      this.notificationText = message;
      this.notificationType = 'error';
      setTimeout(() => { this.notificationText = null; }, 100);
    } finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters('translations', [
      'translate',
    ]),
  },
  methods: {
    async fetchProductMappingItems() {
      const prodVals = await getProductMapping(this.pagination);
      this.items = prodVals;
      this.pagination.total = prodVals.total;
    },
    addNewProductMappingsItem() {
      this.items.unshift({
        tempId: Math.random(),
        name: '',
        finrep_bs_code: '',
        finrep_pl_code: '',
        summary_bs_code: '',
        summary_pl_code: '',
      });
    },
    async saveProductMapping() {
      const rowNum = Object.keys(this.$refs).length;
      const productMappingCreateRequests = [];
      const productMappingUpdateRequests = [];
      let payloadHasInvalidRow = false;
      if (!rowNum) {
        return;
      }

      for (let iterator = 0; iterator < rowNum; iterator += 1) {
        if (this.$refs[`row-${iterator}`].length) {
          this.$refs[`row-${iterator}`][0].validate();
          if (this.$refs[`row-${iterator}`][0].invalidData) {
            payloadHasInvalidRow = true;
          }
        }
      }

      if (payloadHasInvalidRow) {
        return;
      }

      // TODO: Send all capex items in bulk request
      this.loader = true;
      try {
        for (let iterator = 0; iterator < rowNum; iterator += 1) {
          if (!this.items[iterator].id) {
            productMappingCreateRequests.push(createProductMapping(this.items[iterator]));
          } else {
            productMappingUpdateRequests.push(updateProductMapping(this.items[iterator], this.items[iterator].id));
          }
        }
        await Promise.all(productMappingCreateRequests);
        await Promise.all(productMappingUpdateRequests);
        this.notificationText = this.translate('notifications_planning_updated');
        this.notificationType = 'success';
        setTimeout(() => { this.notificationText = null; }, 100);
        await this.fetchProductMappingItems();
      } catch (message) {
        this.notificationText = message;
        this.notificationType = 'error';
        setTimeout(() => { this.notificationText = null; }, 100);
      } finally {
        this.loader = false;
      }
    },
    deleteItem(item) {
      this.itemForDeletion = item;
      this.deleteDialog = true;
      this.deleteDialogDescription = this.translate('dialog_delete_action_description');
    },
    async confirmDeleteAction() {
      if (this.itemForDeletion.item.tempId) {
        this.$delete(this.items, this.itemForDeletion.rowIndex);
        this.deleteDialog = false;
        this.itemForDeletion = null;
        return;
      }
      this.loader = true;

      try {
        await deleteProductMapping(this.itemForDeletion.item.id);
        this.deleteDialog = false;
        this.itemForDeletion = null;
        this.notificationText = this.translate('notifications_item_deleted_successfully');
        this.notificationType = 'success';
        setTimeout(() => { this.notificationText = null; }, 100);
        await this.fetchProductMappingItems();
      } catch (message) {
        this.notificationText = message;
        this.notificationType = 'error';
        setTimeout(() => { this.notificationText = null; }, 100);
      } finally {
        this.loader = false;
      }
    },
    setDialogState(value) {
      this.deleteDialog = value;
    },
  },
  async beforeRouteEnter(from, to, next) {
    await store.dispatch('finrepBsPl/getOptions');
    next();
  },
};
</script>

<style lang="scss" scoped>

.container {
  padding-bottom: 5rem !important;
}

</style>
